export const defaultMembers = {
    totalMembers: 0,
    activeMembers: { value: 0, delta: 0 },
    joinMembers: { value: 0, delta: 0 },
    leftMembers: { value: 0, delta: 0 },
};

export const colSettings = {
    xs: 24,
    sm: 12,
    md: 6,
};

export const getWidgets = members => {
    return [
        {
            title: 'Всего участников',
            value: members.totalMembers,
        },
        {
            title: 'Новых участников',
            highlight: true,
            value: members.joinMembers.value,
            difference: members.joinMembers.delta,
        },
        {
            title: 'Активных участников',
            value: members.activeMembers.value,
            difference: members.activeMembers.delta,
        },
        {
            title: 'Ушедших участников',
            highlight: true,
            value: members.leftMembers.value,
            difference: members.leftMembers.delta,
        },
    ];
};
